import React from "react";

import Loading from "../../../components/Loading";

export function DriverInfoPage({ isLoading, children }) {
  return isLoading ? (
    <Loading active={isLoading} message='' />
  ) : (
    children
  );
}
